import './src/tabchart.less'
import * as MonitoringSaleChannel from './src/MonitoringSaleChannel'
import * as UpdateSaleChannel from './src/UpdateSaleChannel'

export const TabCharts = {
  ...MonitoringSaleChannel,
  ...UpdateSaleChannel,
}
